export default {

  methods: {
    scrollToTop() {
      // 가상 스크롤 컨테이너 요소에 접근합니다.
      const virtualScrollContainer = this.$refs.virtualScroll.$el

      // 컨테이너의 scrollTop을 0으로 설정하여 리스트 아이템을 맨 위로 올립니다.
      virtualScrollContainer.scrollTop = 0
    }

  }
}
